import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import homecook_logo from "../../assets/img/homecook_logo.png";
import NewSearch from "./NewSearch";
import { SearchFilterOptionType } from "../../data/types";
// import { ReactComponent as Filter } from "../../icons/filter.svg";
import { ReactComponent as User } from "../../icons/user.svg";
import { LoginModal, FilterModal, InviteModal } from "../../molecules/Desktop/AppModal";
import LogoutIcon from "@mui/icons-material/Logout";
import { useCompleteSignIn } from "../../hooks/authhooks";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import { ReactComponent as UserIcon } from "../../icons/user.svg";
import { ReactComponent as MyBusinessIcon } from '../../icons/MyBusinessIcon.svg';
import { ReactComponent as HeartIcon } from '../../icons/HeartIcon.svg';
import { ReactComponent as BecomeAPartnerIcon } from '../../icons/BecomeAPartnerIcon.svg';
// import { ReactComponent as HomeIcon } from '../../icons/HomeIcon.svg';
// import { ReactComponent as HomeIconFilled } from '../../icons/HomeIconFilled.svg';
import { ReactComponent as MyBookingsIcon } from '../../icons/MyBookingsIcon.svg';
import { ReactComponent as InviteIcon } from '../../icons/InviteIcon.svg';
import { ReactComponent as NavResourcesIcon } from '../../icons/NavResourcesIcon.svg';
import { ReactComponent as NavResourcesIconDark } from '../../icons/NavResourcesIconDark.svg';
import { ReactComponent as NavCommunitiesIcon } from '../../icons/NavCommunitiesIcon.svg';
// import { ReactComponent as NavCommunitiesIconDark } from '../../icons/NavCommunitiesIconDark.svg';
import NavbarSkeleton from "./NavbarSkeleton";
import { ReactComponent as WalletIcon } from "../../icons/WalletIcon.svg";

import { ReactComponent as NotificationIcon } from "../../icons/Notification.svg";
import { ReactComponent as ClickedNotificationIcon } from "../../icons/ClickedNotificationIcon.svg";
import { ReactComponent as CartIcon } from "../../icons/CartIcon.svg";
import { ReactComponent as ClickedCartIcon } from "../../icons/CartIconFilled.svg";
import { ReactComponent as FeedIcon } from '../../icons/FeedIcon.svg';
import { ReactComponent as ClickedFeedIcon } from '../../icons/FilledFeedIcon.svg'; 

import UserAvatar from "./UserAvatar";
import { capitalizeString } from "../../utils/helpers";
import config from "../../config";
import NoEmailBanner from "../../routers/NoEmailBanner";

const profileMenuList = [
  {
    name: "profile",
    label: "My Profile",
    Icon: UserIcon,
    color: "#000000",
  },
  {
    name: "business",
    label: "My Business",
    Icon: MyBusinessIcon,
    color: "#000000",
  },
  // {
  //   name: "focus-group",
  //   label: "Focus Group",
  //   Icon: MyBusinessIcon,
  //   color: "#000000",
  // },
  {
    name: "saved",
    label: "Saved Resources",
    Icon: HeartIcon,
    color: "#000000",
  },
  {
    name: "bookings",
    label: "My Bookings",
    Icon: MyBookingsIcon,
    color: "#000000",
  },
  {
    name: "wallet",
    label: "Wallet",
    Icon: WalletIcon,
    color: "#000000",
  },
  {
    name: "invite",
    label: "Invite a Friend",
    Icon: InviteIcon,
    color: "#000000",
  },
  {
    name: "partner",
    label: "Become a Partner",
    Icon: BecomeAPartnerIcon,
    color: "#000000",
  },
  {
    name: "logout",
    label: "Logout",
    Icon: LogoutIcon,
    color: "#D42620",
  },
];

type NavbarProps = {
  searchFilterOptions: SearchFilterOptionType;
  loading: boolean;
};

const Navbar: React.FC<NavbarProps> = (props) => {
  const navigate = useNavigate();

  const { user } = useCompleteSignIn();
  const loggedinUsername = user && user?.username ? user.username : "";
  const loggedinUid = user && user?.uid ? user.uid : "";
  const { searchFilterOptions, loading } = props;
  const {
    currentFilter,
    searchTerm,
    signInModalIsOpen,
    setCurrentFilter,
    changeSearchTerm,
    setSignInModalIsOpen,
  } = searchFilterOptions;
  const [filterSetting, setFilterSetting] = useState<boolean>(false);
  const [userOptions, toggleUserOptions] = useState<boolean>(false);
  const [notificationClicked, setNotificationClicked] = useState(false);
  const [inviteModalIsOpen, setInviteModalIsOpen] = useState(false);
  // const [feedClicked, setFeedClicked] = useState(false);
  // const [showCart, setShowCart] = useState(false);
  // const [cartClicked, setCartClicked] = useState(false);
  const [isBeta, setIsBeta] = useState(false);
  // const [width, setWidth] = useState(window.innerWidth);
  const location = useLocation()
  const currentLocation = location.pathname

  // function handleWindowSizeChange() {
  //   setWidth(window.innerWidth);
  // }

  useEffect(() => {
    const checkBetaInURL = () => {
        const currentURL = window.location.href.toLowerCase();
        return currentURL.includes('beta') || currentURL.includes('localhost') || currentURL.includes('homecook.space');
    };
    setIsBeta(checkBetaInURL());
    // window.addEventListener("resize", handleWindowSizeChange);
    // return () => {
    //   window.removeEventListener("resize", handleWindowSizeChange);
    // };
  }, []);

  // const isMobile = width <= 425;
  const notifications: any[] = []
  const cart: any[] = []
  const notificationCount = notifications.length;
  const cartCount = cart.length;

  const toggleFilterSetting = () => {
    setFilterSetting((prev) => !prev);
  };

  const toggleNotifications = () => {
    setNotificationClicked((prev) => !prev);
  };

  const goToFeed = () => {
    navigate(`/feed`)
  };

  const goToCart = () => {
    navigate(`/cart`)
  };


  return (
    <>
    <div className="flex flex-row justify-center items-center bg-primaryLight-1000 fixed w-full z-30 h-16 font-open-sans cursor-pointer border-b-2">
      <div className="flex flex-row items-center w-full max-w-[1920px] px-4 lg:px-6 xl:px-8 mx-auto min-w-0 gap-2 lg:gap-4">
        <div className="flex items-center flex-shrink-0">
          <img
            src={homecook_logo}
            alt="Kitchen Logo"
            className="w-22 h-12 my-auto cursor-pointer"
            onClick={() => navigate("/")}
          />
          <div
            className="flex flex-row text-primaryDark-0 text-xl mr-6 my-auto font-bold cursor-pointer ml-2"
            onClick={() => navigate("/")}
          >
          HomeCook
          {/* Add Beta Tag */}
          {isBeta && (
            <div className="flex items-center gap-1 bg-gradient-to-r from-primaryDark-400 to-primaryDark-300 text-white px-2 py-0.5 rounded-full shadow-md my-auto ml-2 left-0 scale-90">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                <path d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" />
              </svg>
              <span className="font-medium text-xs tracking-wide font-open-sans">BETA</span>
            </div>
          )}
          </div>
        </div>

        {/* Navigation Links */}
        {loading ? (
          <NavbarSkeleton />
        ) : loggedinUid ? (
          <>
            <div className="flex flex-row items-center space-x-6 mr-6 flex-shrink-0">
              {/* <div
                className="flex items-center cursor-pointer"
                onClick={() => navigate("/")}
              >
                {currentLocation === "/" ? <HomeIconFilled className="mt-[2px] mr-1 text-[#013847]" /> : <HomeIcon className="mt-[2px] mr-1 text-[#A1A1A1]" />}
                <p className={`font-raleway text-xs mt-1 ${currentLocation === "/" ? "text-[#013847] font-bold border-b-2 border-[#013847]" : "text-[#A1A1A1]"}`}>
                  Home
                </p>
              </div> */}
              <div
              className="flex items-center cursor-pointer"
              onClick={() => navigate("/")}
              >
                {["/", "/resources", "/kitchen", "/documentation", "/training", "/funding", "/expert", "/farm"].includes(currentLocation) ? <NavResourcesIconDark className="mt-[2px] mr-1 text-[#013847]" /> : <NavResourcesIcon className="mt-[2px] mr-1 text-[#A1A1A1]" />}
                <p className={`font-raleway text-xs mt-1 ${["/", "/resources", "/kitchen", "/documentation", "/training", "/funding", "/expert", "/farm"].includes(currentLocation) ? "text-[#013847] font-bold border-b-2 border-[#013847]" : "text-[#A1A1A1]"}`}>
                  Resources
                </p>
              </div>
              <div
                className="flex items-center cursor-pointer"
                onClick={() => navigate("/communities")}
              >
                {currentLocation === "/communities" ? <NavCommunitiesIcon className="mt-[2px] mr-1 text-[#013847]" /> : <NavCommunitiesIcon className="mt-[2px] mr-1 text-[#A1A1A1]" />}
                <p className={`font-raleway text-xs mt-1 ${currentLocation === "/communities" ? "text-[#013847] font-bold border-b-2 border-[#013847]" : "text-[#A1A1A1]"}`}>
                  Communities
                </p>
              </div>
              <div
                className="flex items-center cursor-pointer"
                onClick={goToFeed}
              >
                {currentLocation === "/feed" ? <ClickedFeedIcon className="mt-[2px] mr-1 text-[#013847]" /> : <FeedIcon className="mt-[2px] mr-1 text-[#A1A1A1]" />}
                <p className={`font-raleway text-xs mt-1 ${currentLocation === "/feed" ? "text-[#013847] font-bold border-b-2 border-[#013847]" : "text-[#A1A1A1]"}`}>
                  Feed
                </p>
              </div>
            </div>
          </>
        ) : (
          <>
          <div className="flex flex-row items-center space-x-6 mr-6 flex-shrink-0">
            <div
              className="flex items-center cursor-pointer"
              onClick={() => navigate("/")}
            >
              {["/", "/resources", "/kitchen", "/documentation", "/training", "/funding", "/expert", "/farm"].includes(currentLocation) ? <NavResourcesIconDark className="mt-[2px] mr-1 text-[#013847]" /> : <NavResourcesIcon className="mt-[2px] mr-1 text-[#A1A1A1]" />}
              <p className={`font-raleway text-xs mt-1 ${["/", "/resources", "/kitchen", "/documentation", "/training", "/funding", "/expert", "/farm"].includes(currentLocation) ? "text-[#013847] font-bold border-b-2 border-[#013847]" : "text-[#A1A1A1]"}`}>
                Resources
              </p>
            </div>
            <div
              className="flex items-center cursor-pointer"
              onClick={() => navigate("/communities")}
            >
              {currentLocation === "/communities" ? <NavCommunitiesIcon className="mt-[2px] mr-1 text-[#013847]" /> : <NavCommunitiesIcon className="mt-[2px] mr-1 text-[#A1A1A1]" />}
              <p className={`font-raleway text-xs mt-1 ${currentLocation === "/communities" ? "text-[#013847] font-bold border-b-2 border-[#013847]" : "text-[#A1A1A1]"}`}>
                Communities
              </p>
            </div>
          </div>
        </>
        )}

        {/* Search and Filter */}
        <div className="flex flex-row items-center flex-1 min-w-0 justify-center">
          <div className="w-full max-w-2xl">
            <NewSearch
              searchTerm={searchTerm}
              toggleFilterSetting={toggleFilterSetting}
              filterSetting={filterSetting}
              changeSearchTerm={changeSearchTerm}
              searchType={"resources"}
            />
          </div>
          {/* <div
            onClick={() => setFilterSetting(true)}
            className={`border-2 p-1 rounded-lg ml-[-40px] w-10 h-10 flex items-center justify-center hover:cursor-pointer ${filterSetting ? "bg-primaryDark-200 text-white" : "bg-primaryLIght-1000 text-black"}`}
          >
            <Filter className={`m-auto ${filterSetting ? "fill-black" : "fill-white"}`} />
          </div> */}
        </div>

        {/* Notification, Cart, and User */}
        {loading ? <NavbarSkeleton /> : loggedinUid ? (
          <div className="flex flex-row items-center space-x-4 ml-6 flex-shrink-0">
            {/* Notifications */}
            <div className="relative bg-[#FAFAFA] h-[44px] w-[44px] rounded-full flex items-center justify-center cursor-pointer" onClick={toggleNotifications} data-testid="notification-icon">
              {notificationClicked ? <ClickedNotificationIcon className="m-auto text-[#013847] h-[22px] w-[22px]" /> : <NotificationIcon className="m-auto text-[#A1A1A1] h-[22px] w-[22px]" />}
              {notificationCount > 0 && (
                <div className="text-white text-[9px] flex items-center justify-center font-bold text-center absolute top-0 w-4 h-4 bg-red-500 rounded-full border-2 border-red-500">
                  {notificationCount}
                </div>
              )}
              {/* <p className={`font-raleway text-xs  mt-1 ml-1 ${notificationClicked ? "text-[#013847] font-bold" : "text-[#A1A1A1]"}`}>
                Notifications
              </p> */}
              {notificationClicked && (
                <div className="absolute top-12 right-0 h-48 w-80 bg-white border border-gray-300 rounded-lg shadow-lg p-2 z-20" onMouseLeave={() => setNotificationClicked(false)}>
                  <h1 className="font-semibold mx-1">Notifications</h1>
                  {notificationCount > 0 ? null : <p className="font-open-sans text-gray-400 text-xs m-1">No Notifications to show</p>}
                </div>
              )}
            </div>
            {/* Cart */}
            <div className="relative bg-[#FAFAFA] h-[44px] w-[44px] rounded-full flex items-center cursor-pointer" onClick={goToCart} data-testid="cart-icon">
              {currentLocation === "/cart" ? <ClickedCartIcon className="m-auto text-[#013847] h-[22px] w-[22px]" /> : <CartIcon className="m-auto text-[#A1A1A1] h-[22px] w-[22px]" />}
              {cartCount > 0 && (
                <div className="text-white text-[9px] flex items-center justify-center font-bold text-center absolute top-0 w-4 h-4 bg-red-500 rounded-full border-2 border-red-500">
                  {cartCount}
                </div>
              )}
              {/* <p className={`font-raleway text-xs mt-1 ml-1 ${currentLocation === "/cart" ? "text-[#013847] font-bold" : "text-[#A1A1A1]"}`}>
                Cart
              </p> */}
            </div>
            {/* User */}
            <div className="flex flex-row items-center text-xs text-black cursor-pointer ml-2 relative">
              {user && user?.avatar ? (
                <div className="flex border-[#E9E9E9] border-[1px] rounded-full h-9 w-9 mr-2" onClick={() => toggleUserOptions(true)}>
                  <img id="image-input-avatar" src={user.avatar} alt="User Avatar" className="h-8 w-8 m-auto rounded-full cursor-pointer" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                </div>
              ) : (
                <UserAvatar
                  firstName={user?.first_name}
                  lastName={user?.last_name}
                  username={user?.username}
                  email={user?.email}
                  size="md"
                  className="mr-2"
                  onClick={() => toggleUserOptions(true)}
                />
              )}
              <div className="flex flex-col" onClick={() => toggleUserOptions(true)}>
                <p className="text-black">Hi, {user && user?.first_name ? user.first_name : ""}</p>
                <p className="my-auto text-[#4D4D4D] hidden sm:block mr-4 truncate">{user?.email || (user?.provider_id ? capitalizeString(user.provider_id.split('.')[0]) : '')}</p>
              </div>
              {userOptions ? (
                <KeyboardArrowUpIcon className="text-black hover:text-primaryDark-300" onClick={() => toggleUserOptions(false)} />
              ) : (
                <KeyboardArrowDownIcon className="text-black hover:text-primaryDark-300" onClick={() => toggleUserOptions(true)} />
              )}
              {userOptions && (
                <div onMouseLeave={() => toggleUserOptions(false)} className="absolute bg-[#fff] p-1 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)] container top-12 sm:px-4 h-auto right-0 z-[9999] sm:w-[276px] origin-top-right bg-white/95 sm:bg-white ring-1 ring-black ring-opacity-5 transition focus:outline-none">
                  <ProfileMenuList inviteModalIsOpen={inviteModalIsOpen} setInviteModalIsOpen={setInviteModalIsOpen} />
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="flex flex-row items-center space-x-4 ml-auto">
            <button
              onClick={() => setSignInModalIsOpen(true)}
              className="bg-primaryDark-100 h-10 min-w-[120px] px-4 py-2 text-sm font-bold text-primaryLight-1000 flex flex-row items-center justify-center gap-2 border-0 cursor-pointer rounded-lg hover:bg-primaryDark-200 transition-colors"
            >
              <User className="w-4 h-4 flex-shrink-0" />
              <span>Sign In</span>
            </button>
          </div>
        )}
      </div>
    </div>

    <LoginModal
      isOpen={signInModalIsOpen}
      setIsOpen={setSignInModalIsOpen}
      closeAppModal={() => {
        setSignInModalIsOpen(false);
      }}
    />
    <FilterModal
      isOpen={filterSetting}
      setIsOpen={setFilterSetting}
      currentFilter={currentFilter}
      setCurrentFilter={setCurrentFilter}
      closeAppModal={() => setFilterSetting(false)}
    />

    <InviteModal
      uid={user?.uid || ""}
      isOpen={inviteModalIsOpen}
      setIsOpen={setInviteModalIsOpen}
      closeAppModal={() => {
        setInviteModalIsOpen(false);
      }}
    />
    {loggedinUid && !loggedinUsername && (
      <NoEmailBanner signInModalIsOpen={signInModalIsOpen} />
    )}
    </>
  ) 
};

type ProfileMenuListProps = { 
  inviteModalIsOpen: boolean;
  setInviteModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProfileMenuList: React.FC<ProfileMenuListProps> = ({inviteModalIsOpen, setInviteModalIsOpen}) => {
  const navigate = useNavigate();
  const { signOut } = useCompleteSignIn();

  return (
    <>
      <div className="py-1 text-center transition cursor-default w-auto my-auto mx-2">
        {profileMenuList &&
          profileMenuList.map((item, i) => {
            return (
              <div
                key={i}
                className={`flex flex-row text-[${item.color}] w-full my-4 font-raleway text-[14px] cursor-pointer hover:bg-slate-50 rounded-md`}
                style={{ color: item.color }}
                onClick={() => {
                  if (item.name === "logout") {
                    signOut();
                    navigate("/");
                  } else if (item.name === "invite") {
                    setInviteModalIsOpen(true);
                  } else if (item.name === "partner") {
                    window.open(config.dashboardUrl, '_blank');
                  } else {
                    navigate(`/${item.name}`);
                  }
                }}
              >
                <div className={`w-1/12 text-left mr-2 my-auto ${(item.name === 'logout') ? '' : ' text-primaryDark-300'}`}>
                  <item.Icon />
                </div>

                <div className={`w-10/12 ml-1 text-left my-auto font-medium`}>
                  {item.label}
                </div>
              </div>
            );
          })}
      </div>

    </>
  );
};

export default Navbar;



